import shinroArticle11 from '@/assets/shinro/shinro-article-1-1.png';
import shinroArticle12 from '@/assets/shinro/shinro-article-1-2.png';
import shinroArticle13 from '@/assets/shinro/shinro-article-1-3.png';
import shinroArticle14 from '@/assets/shinro/shinro-article-1-4.png';

export const Articles1 = [
  {
    image: shinroArticle11,
    title: '進学に関わるお金のQ&A',
    url: 'https://shingakunet.com/rnet/s/hogosha/okane/qa/kihon/',
  },
  {
    image: shinroArticle12,
    title: '進学Journal「今何すべき？Q&A」',
    url: 'https://shingakunet.com/rnet/s/hogosha/schedule/qa/1/',
  },
  {
    image: shinroArticle13,
    title: 'KVママ「併願増やし意外にかさむ受験料」',
    url: 'https://shingakunet.com/rnet/s/hogosha/aruaru/manga23/',
  },
  {
    image: shinroArticle14,
    title: '保護者向け学校紹介',
    url: 'https://shingakunet.com/net/parent/list/gakumon',
  },
];

export const articleThemes = [
  {
    title: '「学費と受験スケジュール、今すぐ知って安心」',
    articles: Articles1,
    release: 'w1',
  },
];
